<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        @submit="handleSubmit"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申领人</span>
              <a-button block style="text-align: left">
                {{ user.userName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item>
              <span class="required" slot="label">申领部门</span>
              <a-button block style="text-align: left">
                {{ department.deptUniqueName }}
              </a-button>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item
              label="申领事由"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
            >
              <a-textarea
                :auto-size="{ minRows: 3 }"
                v-decorator="[
                  'remarks',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <div class="between">
          <div class="title">礼品领用清单</div>
          <AddMaterial @add="add" :canEdit="true"/>
        </div>

        <a-table bordered :dataSource="list" :pagination="false">
          <a-table-column title="礼品名" data-index="name"> </a-table-column>

          <a-table-column title="库存" align="center">
            <template slot-scope="text">
              <span style="color: #1890ff">
                {{ text.quantity }}
              </span>
            </template>
          </a-table-column>

          <a-table-column title="类型">
            <template slot-scope="text">
              <div class="left">
                <DataDictFinder dictType="giftType" :dictValue="text.typeInv" />
                <span>-</span>
                {{ renderSubType(text.typeInv, text.typeSub) }}
              </div>
            </template>
          </a-table-column>

          <a-table-column title="单位" data-index="unit" align="center">
          </a-table-column>
          <a-table-column title="单价" align="center">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ text.unitPrice }}</span>
            </template>
          </a-table-column>

          <a-table-column title="申领数量" align="center">
            <template slot-scope="text">
              <span style="color: #1890ff">{{ text.needQuantity }}</span>
            </template>
          </a-table-column>

          <a-table-column title="操作" align="center" width="100px">
            <template slot-scope="text, record, index">
              <a href="#" class="danger" @click.prevent="remove(index)">
                移除
              </a>
            </template>
          </a-table-column>
        </a-table>

        <div class="center">
          <a-space>
            <a-button htmlType="submit" type="primary" :loading="loading">
              {{ id ? "重新提交" : "保存" }}
            </a-button>
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AddMaterial from "./components/add-material.vue";
import { apply, fetchApplyDetail, reapply } from "@/api/oa/gift";
export default {
  components: {
    AddMaterial,
  },

  data() {
    return {
      form: this.$form.createForm(this),

      list: [],

      loading: false,

      id: null, // 已发起申领申请的 id
    };
  },

  mounted() {
    const { query } = this.$route;
    const { id } = query || {};

    if (id) {
      // 重新提交
      this.id = id;
      fetchApplyDetail({
        id,
      }).then((res) => {
        console.log("result", res);
        if (res) {
          this.form.setFieldsValue({
            remarks: res.remarks,
          });

          this.list = Array.isArray(res.applyMaterials)
            ? res.applyMaterials.map((item) => {
                let obj = item.materialVo ? item.materialVo : {};
                return {
                  needQuantity: item.quantity, // 申领数量
                  ...obj,
                };
              })
            : [];
        }
      });
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["department"]),

    ...mapGetters("setting", ["findDataDict"]),

    typeList() {
      return this.findDataDict("giftType");
    },
  },

  methods: {
    renderSubType(type, subType) {
      const obj = this.typeList.find((item) => item.value === type);
      if (obj && Array.isArray(obj.children)) {
        const subTypeObj = obj.children.find((item) => item.value === subType);
        if (subTypeObj) {
          return subTypeObj.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },

    // 用户选择了品名和数量
    add(payload) {
      const index = this.list.findIndex((item) => item.id === payload.id);
      if (index === -1) {
        this.list.push(payload);
      } else {
        this.list.splice(index, 1, payload);
      }
    },

    remove(index) {
      this.list.splice(index, 1);
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.list.length === 0) {
            this.$message.error("请添加申领物料");
            return;
          }

          this.loading = true;
          const { remarks } = values;

          if (this.id) {
            reapply({
              id: this.id ? this.id : undefined,

              // 申领人
              applicantId: this.user.uuid,
              applicantName: this.user.userName,
              // 申领部门
              deptId: this.department.deptId,
              deptName: this.department.deptUniqueName,

              remarks,

              materialList: this.list.map((item) => {
                return {
                  materialId: item.id,
                  quantity: item.needQuantity,
                  unitPrice: item.unitPrice,
                };
              }),
            })
              .then(() => {
                this.$close(this.$route.path);
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            apply({
              // 申领人
              applicantId: this.user.uuid,
              applicantName: this.user.userName,
              // 申领部门
              deptId: this.department.deptId,
              deptName: this.department.deptUniqueName,

              remarks,

              materialList: this.list.map((item) => {
                return {
                  materialId: item.id,
                  quantity: item.needQuantity,
                  unitPrice: item.unitPrice,
                };
              }),
            })
              .then(() => {
                this.list = [];
                this.form.resetFields();
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.title {
  margin-top: 30px;
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  color: #1890ff;
}

.center {
  margin-top: 80px;
}
</style>
